<app-nav-cliente></app-nav-cliente>
<div class="container-fluid">
    <div class="row">
        <div class="col-lg-2"></div>
        <div class="col-lg-6">
            <h4>Fechas de Pago</h4>
            <strong><span *ngIf="datos_grupo.forma_pago == 1">Plan 1 50/50 <br></span>
            <span *ngIf="datos_grupo.forma_pago == 2">Plan 2 30/30/40 <br></span></strong>
            <p>
                <span *ngIf="datos_grupo.fecha_pago_uno">Fecha de pago 1: {{datos_grupo.fecha_pago_uno}}<br></span>
                <span *ngIf="datos_grupo.fecha_pago_dos">Fecha de pago 2: {{datos_grupo.fecha_pago_dos}}<br></span>
                <span *ngIf="datos_grupo.fecha_pago_tres">Fecha de pago 3: {{datos_grupo.fecha_pago_tres}}<br></span>
            </p>

           
            <p>Monto de compra: ${{totalCliente}}<br>
            Monto por pagar <strong>${{saldo}}</strong></p>

            <h4>Pagos Realizados</h4>
            <table class="table table-striped center">
                <thead>
                    <tr>
                        <td>Fecha</td>
                        <td>Monto</td>
                        <td>Forma de Pago</td>
                        <td>Tipo Pago</td>
                        <td>Recibo</td>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let pago of pagos">
                        <td>{{pago.fecha}}</td>
                        <td>{{pago.forma_pago}}</td>
                        <td>{{pago.tipo_pago}}</td>
                        <td>${{pago.monto}}</td>
                        <td><a href="{{url}}/api/reciboPago?pago={{pago.id}}" target="_blank">Ver Pago</a></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td class="bold">Total</td>
                        <td class="bold">${{total}}</td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        
        </div>
        <div class="col-lg-3">
            <app-mi-paquete></app-mi-paquete>
        </div>
        <div class="col-lg-1"></div>
    </div>
</div>